<template>
    <div class="HelpCenter__form">
        <div class="Form__group">
            <input type="text"
                   name="subject"
                   class="Form__text"
                   placeholder="Subject"
                   v-model.trim="form.subject"
                   @keyup="clearErrors('subject')"
            >
            <div class="Form__error">{{ errors.subject }}</div>
        </div>

        <div class="Form__group">
            <textarea name="message"
                      class="Form__text Form__text--textarea"
                      placeholder="Message"
                      v-model="form.message"
                      @keyup="clearErrors('message')"
            ></textarea>
            <div class="Form__error">{{ errors.message }}</div>
        </div>

        <div class="Form__group">
            <a href="#" class="Button Button--max-width" @click.prevent="send">Send Message</a>
        </div>

        <div :class="successClasses">
            Your message has been sent.
        </div>
    </div>
</template>

<script>
    import Form from './../../mixins/form';

    export default {
        data() {
            return {
                form: {
                    subject: '',
                    message: '',
                },

                errors: {
                    subject: '',
                    message: '',
                },
            }
        },

        mixins: [Form],

        computed: {
            successClasses() {
                return {
                    'HelpCenter__form-success': true,
                    'HelpCenter__form-success--show': this.showSuccess,
                }
            }
        },
    }
</script>